export default function initFixedHeader() {
    const target = document.getElementById('header');

    if (!target) {
        return;
    }

    const fixedHeader = () => {
        const top = window.pageYOffset || document.documentElement.scrollTop;
        if (top >= 125) {
            target.classList.add('fixed-header');
        } else {
            target.classList.remove('fixed-header');
        }
    };
    window.onscroll = function () {
        fixedHeader();
    };
    fixedHeader();

    function scrollDirection() {
        let prevST = 0;
        const activeClass = 'scroll-top';

        changeHandler();
        window.addEventListener('scroll', changeHandler);
        window.addEventListener('resize', changeHandler);

        function changeHandler() {
            const sT = window.pageYOffset;

            if (prevST !== sT) {
                if (sT < prevST && !target.classList.contains(activeClass)) {
                    target.classList.add(activeClass);
                } else if (sT >= prevST && target.classList.contains(activeClass)) {
                    target.classList.remove(activeClass);
                }
            }
            prevST = sT;
        }
    }

    scrollDirection();
}
